var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-reviews"},[_c('v-container',{staticClass:"section-reviews__container"},[_c('v-row',{staticClass:"justify-center",attrs:{"no-gutters":""}},[_c('h2',{staticClass:"section-reviews__title"},[_vm._v("Why customers love us")])]),_c('QuoteCarousel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }